<template>
  <TableRow class="border-primary-400">
    <TableHead class="text-neutral-50 font-normal">
      <slot name="head" />
    </TableHead>
    <TableCell
      class="text-right text-neutral-50 font-normal empty:after:content-['\00a0']"
    >
      <slot name="cell" />
    </TableCell>
  </TableRow>
</template>

<script setup>
import { TableRow, TableHead, TableCell } from '@ui/components/table';
</script>
